/* UTF-8 admin tab: chat */
import React from 'react'

export function renderChat(ctx) {
  const {
    activeTab,
    adminReply,
    chatActiveSession,
    chatEndRef,
    chatSessionMsgs,
    chatSessions,
    handleSelectChatSession,
    handleSendReply,
    setAdminReply,
    t,
  } = ctx
  return (
    <>
          {activeTab === 'chat' && (
            <div className="dash-section dash-chat-section">
              <div className="dash-section-header">
                <h2>{t.liveChatTitle}</h2>
                <p>{t.respondCustomers}</p>
              </div>
              <div className="dash-it-layout">
                {/* Session list */}
                <div className="dash-it-list">
                  {chatSessions.length === 0 ? (
                    <div style={{ padding: '20px', color: '#888', fontSize: '0.85rem' }}>No conversations yet</div>
                  ) : chatSessions.map(s => (
                    <div
                      key={s.sessionId}
                      className={`dash-it-conv-item${chatActiveSession === s.sessionId ? ' active' : ''}`}
                      onClick={() => handleSelectChatSession(s.sessionId)}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <strong style={{ fontSize: '0.9rem' }}>{s.name || 'Visitor'}</strong>
                        <span style={{ fontSize: '0.72rem', color: '#9ca3af' }}>{s.messageCount} msg{s.messageCount !== 1 ? 's' : ''}</span>
                      </div>
                      {s.lastMessage && <div style={{ fontSize: '0.78rem', color: '#666', marginTop: '3px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{s.lastMessage}</div>}
                    </div>
                  ))}
                </div>
                {/* Chat panel */}
                <div className="dash-it-chat-panel">
                  {!chatActiveSession ? (
                    <div className="dash-empty-state"><span>💬</span><p>Select a conversation</p></div>
                  ) : (
                    <>
                      <div className="dash-it-messages">
                        {chatSessionMsgs.map(msg => (
                          <div key={msg.id} className={`dash-it-msg ${msg.sender === 'admin' ? 'admin' : msg.sender === 'ai' ? 'ai' : 'worker'}`}>
                            <div className="dash-chat-msg-header">
                              <span className="dash-chat-sender">
                                {msg.sender === 'admin' ? 'You' : msg.sender === 'ai' ? 'AI Assistant' : msg.name || 'Visitor'}
                              </span>
                              <span className="dash-chat-time">{new Date(msg.timestamp).toLocaleString()}</span>
                            </div>
                            <div className="dash-chat-text">{msg.text}</div>
                          </div>
                        ))}
                        <div ref={chatEndRef} />
                      </div>
                      <div className="dash-chat-toolbar">
                        <span className="dash-chat-count">{chatSessionMsgs.length} {chatSessionMsgs.length !== 1 ? t.messages : t.message}</span>
                      </div>
                      <form className="dash-it-reply-form" onSubmit={handleSendReply}>
                        <input type="text" className="dash-chat-input" value={adminReply} onChange={e => setAdminReply(e.target.value)} placeholder={t.typeReply} />
                        <button className="dash-btn primary" type="submit">{t.sendReply}</button>
                      </form>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* ── TRACKING ─────────────────────────────────────── */}
    </>
  )
}
